import React, { Fragment, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import { withAreaGetter } from 'providers/AreasConsumers';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_SCORING } from 'constants/rightsCodes';

import FinancialIndicatorContainer from './FinancialIndicatorContainer';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState('');
  const { getElemByAreaKey } = props;
  const id = props.match.params.id && getInt(props.match.params.id);

  const onClickClose = () => {
    historyContext.push(`/financialIndicators`);
  };

  const onChangeTitle = financialIndicatorTitle => {
    setTitle(financialIndicatorTitle);
  };

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/financialIndicators/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SCORING}>
        <FinancialIndicatorContainer id={id} onChangeTitle={onChangeTitle} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(withRouter(Route));
